export enum FontWeight {
  Bold = 700,
  Normal = 400,
}
